import Store from '../../store'
import ENUM from '../../assets/ENUM'
import Storage from '../../helpers/storage'
import Firebase from '../../modules/firebase'
import {configuration} from '../../../configuration'


const Cards = {

    async addSpecialsCards(array) {

        if (!Storage.getItem(Storage.KEYS.SHARING_CARD)) {
            const sharingCard = {type: ENUM.NEWSLETTERS.CARDS.SHARING}
            await Firebase.getValue('sharing_cards_positions', 'Object')
                .then(firebaseData => {
                    return firebaseData && firebaseData.positions
                        ? addCardWithPosition(array, firebaseData.positions, sharingCard)
                        : addCardWithPosition(array, configuration.sharingCardsPositionDefault, sharingCard)
                })
                .catch(() => {
                    return addCardWithPosition(array, configuration.sharingCardsPositionDefault, sharingCard)
                })

        }

        for (const specialCard of Store.getters.newslettersExtras) {
            addCardWithPosition(array, [specialCard.position], {
                ...specialCard,
                type: ENUM.NEWSLETTERS.CARDS.MARKET
            })
        }

        addFoxyCardsAnimation(array)

        return array
    }

}


export default Cards


function addCardWithPosition(array, positions = [], card = {}) {
    positions.forEach(position => {
        if (array.length > position) {
            const uniqueCard = JSON.parse(JSON.stringify(card))

            uniqueCard.sender = uniqueCard.sender || position

            array.splice(position, 0, uniqueCard)
        }
    })
    return array
}

function addFoxyCardsAnimation(array) {
    // There are 2 animated cards which should each be displayed only if they have already been seen.
    // Adding 'A' and 'B' is a way of saving which has already been seen
    if (!Storage.getItem(ENUM.NEWSLETTERS.SPECIALS.USED_FOXY_CARD_ANIMATIONA)) {
        addCardWithPosition(array, [25], {
            type: ENUM.NEWSLETTERS.CARDS.ANIMATION,
            name: ENUM.NEWSLETTERS.SPECIALS.USED_FOXY_CARD_ANIMATIONA
        })
    }
    if (!Storage.getItem(ENUM.NEWSLETTERS.SPECIALS.USED_FOXY_CARD_ANIMATIONB)) {
        addCardWithPosition(array, [50], {
            type: ENUM.NEWSLETTERS.CARDS.ANIMATION,
            name: ENUM.NEWSLETTERS.SPECIALS.USED_FOXY_CARD_ANIMATIONB
        })
    }
}
